import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock";

let lockedElems = 0;

function lockBody(target, options) {
    const opts = Object.assign(
        {
            allowTouchMove: (el) => {
                return el !== document.body ? true : false;
            },
        },
        options,
    );

    disableBodyScroll(target, opts);
    lockedElems++;
}

function unlockBody() {
    if (lockedElems <= 1) {
        clearAllBodyScrollLocks();
    }

    lockedElems--;
}

function scrollLocker(value) {
    const body = document.querySelector("body");

    function getBodyScrollTop() {
        return (
          self.pageYOffset ||
          (document.documentElement && document.documentElement.ScrollTop) ||
          (document.body && document.body.scrollTop)
        );
    }
    
    function existVerticalScroll() {
        return document.body.offsetHeight > window.innerHeight;
    }

    if (value === "lock") {
        body.dataset.scrollY = `${getBodyScrollTop()}`; // сохраним значение скролла
    
        if (existVerticalScroll()) {
            body.classList.add("body-lock");
            body.style.top = `-${body.dataset.scrollY}px`;
        }
    } else if (value === "unlock") {

        if (existVerticalScroll()) {
            body.removeAttribute("class");
            window.scrollTo(0, +body.dataset.scrollY);
        }
    } else {
        return console.error("Передано неверное значение аргумента");
    }
}

export { lockBody, unlockBody, scrollLocker };
